// extracted by mini-css-extract-plugin
export default {"pin":"KasaMap_pin__KOaiA","currentDot":"KasaMap_currentDot__z0lh4"};